import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { LoggingSettingsFeatureGate } from '../Guards/LoggingSettingsFeatureGate'
import { LoggingSettingsList } from '../Components/Organisms/LoggingSettingsList/LoggingSettingsList'

/**
 * Routed logging settings page.
 */
@Route(RouteID.LOGGING_SETTINGS)
export class LoggingSettingsPage extends Component {
    /**
     * Renders logging settings page content tree.
     *
     * @returns Logging settings page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.LOGGING_SETTINGS}>
                <LoggingSettingsFeatureGate>
                    <LanguageContextProvider>
                        <LoggingSettingsList />
                    </LanguageContextProvider>
                </LoggingSettingsFeatureGate>
            </RouteGuard>
        )
    }
}
